import { DeleteFormValidation, DeleteFormValues } from '../../../types'
import { useTexts } from './useTexts'

const validateForm =
  (texts: ReturnType<typeof useTexts>) =>
  async (formValues: DeleteFormValues): Promise<DeleteFormValidation> => {
    const { c1, c2, c3, c4 } = formValues

    const validation: DeleteFormValidation = {}

    if (!c1) {
      validation.c1 = texts.validation.notAllChecked
    }
    if (!c2) {
      validation.c2 = texts.validation.notAllChecked
    }
    if (!c3) {
      validation.c3 = texts.validation.notAllChecked
    }
    if (!c4) {
      validation.c4 = texts.validation.notAllChecked
    }

    return validation
  }

export const useValidateForm = () => {
  const texts = useTexts()
  return async (formValues: DeleteFormValues) => {
    return validateForm(texts)(formValues)
  }
}
